module.exports = __webpack_public_path__ + "static/media/icon_exit.b36c1cc4.png";